import { mergeStoreCopy } from './content/siteCopyHelpers';

/** Merged store_copy with all defaults applied (cart, checkout, shop, nav, etc.). */
export function getMergedStoreCopy(settings) {
  return mergeStoreCopy(settings?.store_copy);
}

/** Replace `{key}` placeholders in admin copy templates. */
export function fillCopyTemplate(template, vars = {}) {
  return String(template || '').replace(/\{(\w+)\}/g, (_, key) => {
    const val = vars[key];
    return val == null ? '' : String(val);
  });
}
